// Derived from legacy-document-page/client/src/modules/Reader/Reader.js
export enum ReaderMessageType {
    keyLeft = 'KEY_LEFT',
    keyRight = 'KEY_RIGHT',
    goToPage = 'GO_TO_PAGE',
    showLargeViewButtonEngaged = 'SHOW_LARGE_VIEW_BUTTON_ENGAGED',
    showLargeViewButtonDisengaged = 'SHOW_LARGE_VIEW_BUTTON_DISENGAGED',
    hideLargeViewButton = 'HIDE_LARGE_VIEW_BUTTON',
    enableTracking = 'ENABLE_TRACKING',
    showFindDialog = 'SHOW_FIND_DIALOG',
    sendQueuedMessages = 'SEND_QUEUED_MESSAGES',
    stopMessageQueue = 'STOP_MESSAGE_QUEUE',
}

export const MIN_CONTENT_WIDTH = 360;
export const MAX_CONTENT_WIDTH = 1340;

export enum breakpointWidths {
    tinyMax = 480, // A common maximum width for mobile phones in portrait aspect
    smallMin,
    smallMax = 768, // A common width for tablets in portait aspect
    singleColMin,
    singleColMax = 1099, // > Width of large leaderboard ad + width of narrow Primis ad => 768 + 300 = 1068
    twoColMin,
    twoColMax = 1699, // > MAX_CONTENT_WIDTH + 2 * (gutter width + narrow skyscraper) => 1340+2(16+160) = 1692
    wideScreenMin,
}

export const STREAM_NAMES = ['read-more', 'similar-to', 'popular-now', 'just-for-you'] as const;

export const HEADER_Z_INDEX = 10000;
export const HEADER_HEIGHT = '52px';

export const isSafariIOS =
    'navigator' in globalThis &&
    /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(navigator.userAgent);
